import React from 'react';
import Header from '../navbar/Header';
import Container from '../Container';
import Content from '../Content';
import Navbar from '../navbar/Navbar';
import TaskReport from './TaskReport';

function Report() {
    return ( 
        <Container>
            <Navbar/>

            <Content>

             <TaskReport/>
            </Content>
        </Container>
     );
}

export default Report;